import type { ChartDateRange } from "@bloomberg/octagon-shared";

const subMonths = (date: Date, months: number): Date => {
  const d = new Date(date);
  const dayOfMonth = d.getDate();

  d.setMonth(d.getMonth() - months);
  if (d.getDate() !== dayOfMonth) {
    d.setDate(0);
  }

  return d;
};

const subYears = (date: Date, years: number): Date => {
  const d = new Date(date);
  const dayOfMonth = d.getDate();

  d.setFullYear(d.getFullYear() - years);
  if (d.getDate() !== dayOfMonth) {
    d.setDate(0);
  }

  return d;
};

const startOfYear = (date: Date): Date => {
  // Use noon UTC to avoid timezone-boundary issues when formatting in NY time
  return new Date(Date.UTC(date.getFullYear(), 0, 1, 12, 0, 0));
};

const nyTimeFormat = (date: Date): string => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));

  return `${map.year}-${map.month}-${map.day}`;
};

export function getChartDates(chartDateRange: ChartDateRange) {
  const today = new Date();
  const endDate = nyTimeFormat(today);

  let startDate;

  switch (chartDateRange) {
    case "1M":
      startDate = nyTimeFormat(subMonths(today, 1));
      break;
    case "6M":
      startDate = nyTimeFormat(subMonths(today, 6));
      break;
    case "YTD":
      startDate = nyTimeFormat(startOfYear(today));
      break;
    case "1Y":
      startDate = nyTimeFormat(subYears(today, 1));
      break;
    case "5Y":
      startDate = nyTimeFormat(subYears(today, 5));
      break;
    default:
      startDate = nyTimeFormat(today);
  }

  return { startDate, endDate };
}
